import { createPermission } from '@backstage/plugin-permission-common';

export const SALSA_HOSTING_CLOUDAPP_RESOURCE_TYPE = 'CloudApp';
export const SALSA_HOSTING_CLOUDENV_RESOURCE_TYPE = 'CloudEnv';
export const SALSA_HOSTING_CLOUDORG_RESOURCE_TYPE = 'CloudOrg';

/** Manage (start/stop/redeploy) non-production environments */
export const salsaHostingCloudAppNonprodPermission = createPermission({
  name: 'salsa.hosting.cloudapp.nonprod.manage',
  attributes: { action: 'update' },
  resourceType: SALSA_HOSTING_CLOUDAPP_RESOURCE_TYPE,
});

/** Manage (start/stop/redeploy) production environments */
export const salsaHostingCloudAppProdPermission = createPermission({
  name: 'salsa.hosting.cloudapp.prod.manage',
  attributes: { action: 'update' },
  resourceType: SALSA_HOSTING_CLOUDAPP_RESOURCE_TYPE,
});
